import { useCallback, useEffect, useState } from "react"

import {
  fetchGupshupSettings,
  testGupshupConnection,
  updateGupshupSettings,
} from "src/features/integrations/api/gupshupApi"

// Loads + mutates the org's Gupshup credentials. Mirrors the hand-rolled
// load/mutate hook style used elsewhere (e.g. useTemplates).
export function useGupshupSettings() {
  const [config, setConfig] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [isTesting, setIsTesting] = useState(false)

  const load = useCallback(async () => {
    setIsLoading(true)
    try {
      setConfig(await fetchGupshupSettings())
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  const save = useCallback(async (payload) => {
    setIsSaving(true)
    try {
      const next = await updateGupshupSettings(payload)
      setConfig(next)
      return next
    } finally {
      setIsSaving(false)
    }
  }, [])

  const test = useCallback(async (toAddress) => {
    setIsTesting(true)
    try {
      return await testGupshupConnection(toAddress)
    } finally {
      setIsTesting(false)
    }
  }, [])

  return { config, isLoading, isSaving, isTesting, save, test, reload: load }
}
